import {
    GET_ROUTINE_LOG_REQUEST,
    GET_ROUTINE_LOG_SUCCESS,
    GET_ROUTINE_LOG_ERROR
  } from "../actions/types";
  
  export const RoutineLog = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_ROUTINE_LOG_REQUEST:
        return {
          loading: true,
        };
      case GET_ROUTINE_LOG_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ROUTINE_LOG_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
      default: {
        return state;
      }
    }
  };